import {useContext} from 'react';
import {InfoBoxType, Language, LanguageContext} from './app';
import {i18n} from './i18n';

export interface InfoBoxContentProps {
  readonly setInfoBoxType: React.Dispatch<
    React.SetStateAction<InfoBoxType | undefined>
  >;
  readonly infoBoxType: InfoBoxType | undefined;
}

export function InfoBoxContent({
  setInfoBoxType,
  infoBoxType,
}: InfoBoxContentProps) {
  if (!infoBoxType) {
    return null;
  }
  const language = useContext(LanguageContext);
  const translations = i18n[language];
  const headline = translations.settings[infoBoxType].title;
  const copy = translations.settings[infoBoxType].copy;
  return (
    <div className="relative grid flex-row gap-y-4 bg-white p-5 sm:p-8 md:p-12 lg:p-16">
      <h3>{headline}</h3>
      <p>{copy}</p>
      <button
        type="submit"
        className={
          'text-gray ml-auto mr-auto block w-fit rounded border-none hover:opacity-50'
        }
        onClick={() => {
          setInfoBoxType(undefined);
        }}
      >
        close
      </button>
    </div>
  );
}
